import { SVGProps } from 'react';

interface ChurchLogoProps extends SVGProps<SVGSVGElement> {
    size?: number | string;
    strokeWeight?: number; // Pozwala ręcznie dobrać grubość, domyślnie 2px
}

export const ChurchLogo = ({ 
    size = 64, 
    strokeWeight = 2, 
    className, 
    ...props 
}: ChurchLogoProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
    >
        <path 
            vectorEffect="non-scaling-stroke"
            strokeWidth={strokeWeight}
            d="M3 28h26 M16 2v5 M13.5 4.5h5 M10 28V13l6-6 6 6v15 M10 18l6-5 6 5 M10 15l-6 5v8 M22 15l6 5v8 M13 28v-3a3 3 0 0 1 6 0v3 M6 24h2" 
        />
        <circle 
            vectorEffect="non-scaling-stroke"
            strokeWidth={strokeWeight}
            cx="16"
            cy="19.5"
            r="1.5" 
        />
    </svg>
);
